import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomLayoutService } from 'app/services/custom-layout.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SlideTypeLinesService } from '@app/services/slide-type-lines.service';
import { LINE_AUTO_CONDITIONS, LINE_AUTO_SOURCES } from '@app/constants/line-auto-options';


@Component({
  selector: 'app-layout-lines',
  templateUrl: './layout-lines.component.html',
})
export class LayoutLinesComponent implements OnInit {
  layoutLineForm!: FormGroup;
    ShapeTypeOptions: any[] = [];
  readonly lineAutoSources = LINE_AUTO_SOURCES;
  readonly lineAutoConditions = LINE_AUTO_CONDITIONS;
  shortcode: string = '';
  shapeBorderTypes: any[] = [];
shapeShadowTypes: any[] = [];
  // Group visibility flags (global)
  groupVisibility = {
    group2: true,
    group3: true,
    group4: true,
    group5: true,
    group6: true,
    group7: true,
  };


  constructor(private route: ActivatedRoute, private fb: FormBuilder, private SlideTypeLinesService: SlideTypeLinesService, private CustomLayoutService: CustomLayoutService, private router: Router) { }

  ngOnInit(): void {
    console.log("Init form");
    console.log(this.route.snapshot.params);
    this.shortcode =  this.route.snapshot.params['id'];
    
    this.layoutLineForm = this.fb.group({
      // Header fields
      LayoutShortCode: this.fb.control,
      LayoutDescription: this.fb.control,
      LayoutRemarks: this.fb.control,
      // Detail rows
      details: this.fb.array([]),
    });

    // Load dropdown data for group 1
    this.CustomLayoutService.getSlideObjectTypes("CL").subscribe((data) => {
      console.log("drop down options for shapetype");
      console.log(data);
      this.ShapeTypeOptions = data;
    });

 this.SlideTypeLinesService.getSlideTypeMasterCodes("BORDERTYP").subscribe(types => {
      this.shapeBorderTypes = types;
    });
     console.log(this.shapeBorderTypes);
     this.SlideTypeLinesService.getSlideTypeMasterCodes("SHADOWTYP").subscribe(types => {
      this.shapeShadowTypes = types;
    });
     console.log(this.shapeShadowTypes);
    // Load layout data

    console.log('calling loadlayout');
    console.log(this.shortcode);
    this.loadLayout(this.shortcode);
  }

  get detailsFormArray(): FormArray {
    return this.layoutLineForm.get('details') as FormArray;
  }

  // Load data from backend
  loadLayout(shortcode: string): void {
    //debugger;
    this.CustomLayoutService.getcustomLayoutWithSC(shortcode).subscribe((data) => {
      console.log(data);
      let cl = data[0];
      this.layoutLineForm.patchValue(cl);
    });

    this.CustomLayoutService.getcustomLayoutLinesByShortCode(shortcode).subscribe((rows) => {
      this.detailsFormArray.clear();
      rows.forEach((row: any) => {
        console.log(row);
        this.detailsFormArray.push(this.createRowForm(row));
      });
      console.log(this.detailsFormArray);

    });
    this.layoutLineForm.patchValue(this.detailsFormArray);
  }
  //LayoutShortCode, LayLineSrNo, LLName, LLShapeType, LLSource, LLLable, LLShapeBorder, LLShapeShadow, LLShapeFill, LLTextFont, LLTextColor, LLXpos, LLYpos, LLWidth, LLHeaight, LLComment
  // Create row FormGroup (with optional initial data)
  createRowForm(data: any = {}): FormGroup {
    return this.fb.group({
     
      LLName: [data.LLName || ''],
      LLShapeType: [data.LLShapeType || ''],

      LLSource: [data.LLSource || ''],
      LLLable: [data.LLLable || ''],

      LLShapeBorder: [data.LLShapeBorder || ''],
      LLShapeShadow: [data.LLShapeShadow || ''],
      LLShapeFill: [data.LLShapeFill || ''],


      LLTextFont: [data.LLTextFont || ''],
      LLTextColor: [data.LLTextColor || ''],

      LLXpos: [data.LLXpos || ''],
      LLYpos: [data.LLYpos || ''],
      LLWidth: [data.LLWidth || ''],
      LLHeaight: [data.LLHeaight || ''],

      LLComment: [data.LLComment || ''],
      LLAutoSource: [data.LLAutoSource || ''],
      LLAutoVal: [data.LLAutoVal ?? ''],
      LLAutoCondition: [data.LLAutoCondition || ''],
    });
  }

  // Row operations
  addRow(): void {
    this.detailsFormArray.push(this.createRowForm());
  }

  deleteRow(index: number): void {
    this.detailsFormArray.removeAt(index);
  }

  moveRowUp(index: number): void {
    if (index > 0) {
      const row = this.detailsFormArray.at(index);
      this.detailsFormArray.removeAt(index);
      this.detailsFormArray.insert(index - 1, row);
    }
  }

  moveRowDown(index: number): void {
    if (index < this.detailsFormArray.length - 1) {
      const row = this.detailsFormArray.at(index);
      this.detailsFormArray.removeAt(index);
      this.detailsFormArray.insert(index + 1, row);
    }
  }

  toggleGroup(groupName: keyof typeof this.groupVisibility): void {
    this.groupVisibility[groupName] = !this.groupVisibility[groupName];
  }

  save(): void {
    if (this.layoutLineForm.valid) {
      const payload = this.layoutLineForm.value;
      console.log('Saving form', payload);
       this.CustomLayoutService.savecustomLayout(payload).subscribe(() => {
      this.router.navigate(['/designer/layout-list']);
    });
    }
  }
}
